import {
  type DashRouteType,
  URL_APP_ADMIN,
  URL_RETAILER_SCOPED,
  URL_PARTNER_SCOPED,
} from '@retailer-platform/dashboard/routing'

const URL_CONNECTED_STORES = `${URL_APP_ADMIN}/connected-stores`
const URL_CONNECTED_STORES_RETAILER_SCOPE = `${URL_RETAILER_SCOPED}/connected-stores`
const URL_CONNECTED_STORES_PARTNER_SCOPE = `${URL_PARTNER_SCOPED}/connected-stores`

// Caper
const URL_CONNECTED_STORES_CAPER = `${URL_CONNECTED_STORES}/caper`
const URL_CONNECTED_STORES_CAPER_SESSION_REPLAY = `${URL_CONNECTED_STORES_CAPER}/session-replay`
const URL_CONNECTED_STORES_CAPER_CONFIG = `${URL_CONNECTED_STORES_CAPER}/config/:environment`
const URL_CONNECTED_STORES_CAPER_CONFIG_KEYS = `${URL_CONNECTED_STORES_CAPER}/config-keys/`
const URL_CONNECTED_STORES_CAPER_FEATURES = `${URL_CONNECTED_STORES_CAPER}/features`
const URL_CONNECTED_STORES_CAPER_FEATURE_APPROVALS = `${URL_CONNECTED_STORES_CAPER}/feature-approvals`
const URL_CONNECTED_STORES_CAPER_FEATURE_DASHBOARD = `${URL_CONNECTED_STORES_CAPER}/feature-dashboard`
const URL_CONNECTED_STORES_CAPER_AUDIT = `${URL_CONNECTED_STORES_CAPER}/audit`
const URL_CONNECTED_STORES_CAPER_BAN_LIST = `${URL_CONNECTED_STORES_CAPER}/ban-list/:environment`
const URL_CONNECTED_STORES_CAPER_NOTIFICATION_GROUPS = `${URL_CONNECTED_STORES_CAPER}/notification-groups/:environment`
const URL_CONNECTED_STORES_CAPER_SCHEDULED_ACTIONS = `${URL_CONNECTED_STORES_CAPER}/scheduled-actions/:environment`
const URL_CONNECTED_STORES_CAPER_CONFIG_CREATE = `${URL_CONNECTED_STORES_CAPER}/config/:environment/create`
const URL_CONNECTED_STORES_CAPER_CONFIG_PARTNER = `${URL_CONNECTED_STORES_CAPER}/config/:environment/:partner`
const URL_CONNECTED_STORES_CAPER_CONFIG_RETAILER = `${URL_CONNECTED_STORES_CAPER}/config/:environment/:partner/:retailer`
const URL_CONNECTED_STORES_CAPER_CONFIG_STORE = `${URL_CONNECTED_STORES_CAPER}/config/:environment/:partner/:retailer/:store`
const URL_CONNECTED_STORES_CAPER_CONFIG_DEVICE = `${URL_CONNECTED_STORES_CAPER}/config/:environment/:partner/:retailer/:store/:device`

// Upos
const URL_CONNECTED_STORES_UPOS = `${URL_CONNECTED_STORES}/upos`
const URL_CONNECTED_STORES_UPOS_STATUS = `${URL_CONNECTED_STORES_UPOS}/status/:id?`
const URL_CONNECTED_STORES_UPOS_RETAILERS = `${URL_CONNECTED_STORES_UPOS}/retailers/:id?`
const URL_CONNECTED_STORES_UPOS_PROFILES = `${URL_CONNECTED_STORES_UPOS}/profiles/:id?`
const URL_CONNECTED_STORES_UPOS_STORES = `${URL_CONNECTED_STORES_UPOS}/stores/:id?`
const URL_CONNECTED_STORES_UPOS_INTEGRATIONS = `${URL_CONNECTED_STORES_UPOS}/integrations/:id?`

// Unified Barcodes
const URL_CONNECTED_STORES_UNIFIED_BARCODES = `${URL_CONNECTED_STORES}/unified-barcodes`

// Shelf Labels
const URL_CONNECTED_STORES_SHELF_LABELS = `${URL_CONNECTED_STORES}/shelf-labels`
const URL_CONNECTED_STORES_SHELF_LABELS_STORES = `${URL_CONNECTED_STORES_SHELF_LABELS}/stores/:id?`
const URL_CONNECTED_STORES_SHELF_LABELS_CONNECTIONS = `${URL_CONNECTED_STORES_SHELF_LABELS}/connections/:id?`
const URL_CONNECTED_STORES_SHELF_LABELS_SYNC_STRATEGIES = `${URL_CONNECTED_STORES_SHELF_LABELS}/sync-strategies/:id?`
const URL_CONNECTED_STORES_SHELF_LABELS_AUTOMATIONS = `${URL_CONNECTED_STORES_SHELF_LABELS}/automations/:id?`

// Not on File
const URL_CONNECTED_STORES_NOT_ON_FILE = `${URL_CONNECTED_STORES}/not-on-file/:environment`
const URL_CONNECTED_STORES_NOT_ON_FILE_DETAILS = `${URL_CONNECTED_STORES}/not-on-file/:environment/:id`

// Payment Terminals
const URL_CONNECTED_STORES_PAYMENT_TERMINALS = `${URL_CONNECTED_STORES_CAPER}/payment-terminals/:environment`
const URL_CONNECTED_STORES_PAYMENT_TERMINALS_DETAILS = `${URL_CONNECTED_STORES_CAPER}/payment-terminals/:environment/:id`

// Device Provisioning Pipeline
const URL_CONNECTED_STORES_DEVICE_PROVISIONING_PIPELINE = `${URL_CONNECTED_STORES}/device-provisioning-pipeline/:environment`

// Caper Transactions
const URL_CONNECTED_STORES_RETAILER_SCOPE_CAPER_TRANSACTIONS = `${URL_CONNECTED_STORES_RETAILER_SCOPE}/caper-transactions`

// Not on File (Retailer Scope)
const URL_CONNECTED_STORES_RETAILER_SCOPE_NOT_ON_FILE = `${URL_CONNECTED_STORES_RETAILER_SCOPE}/not-on-file/`
const URL_CONNECTED_STORES_RETAILER_SCOPE_NOT_ON_FILE_DETAILS = `${URL_CONNECTED_STORES_RETAILER_SCOPE}/not-on-file/:id`

// Not on File (Partner Scope)
const URL_CONNECTED_STORES_PARTNER_SCOPE_NOT_ON_FILE = `${URL_CONNECTED_STORES_PARTNER_SCOPE}/not-on-file/:environment`
const URL_CONNECTED_STORES_PARTNER_SCOPE_NOT_ON_FILE_DETAILS = `${URL_CONNECTED_STORES_PARTNER_SCOPE}/not-on-file/:environment/:id`

// Inventory Intelligence (Retailer Scope)
const URL_CONNECTED_STORES_RETAILER_SCOPE_INVENTORY_INTELLIGENCE = `${URL_CONNECTED_STORES_RETAILER_SCOPE}/inventory-intelligence/:storeId`

// Staff Barcode Management (Retailer Scope)
const URL_CONNECTED_STORES_RETAILER_SCOPE_STAFF_BARCODE_MANAGEMENT = `${URL_CONNECTED_STORES_RETAILER_SCOPE}/staff-barcode-management`

// @hygen:inject scoped-urls

export type DashRouteSet =
  | DashRouteType<'app-admin-connected-stores'>
  | DashRouteType<'app-retailer-scope-connected-stores'>
  | DashRouteType<'app-partner-scope-connected-stores'>

  // Caper
  | DashRouteType<'app-admin-connected-stores-caper'>
  | DashRouteType<'app-admin-connected-stores-caper-session-replay'>
  | DashRouteType<'app-admin-connected-stores-caper-config'>
  | DashRouteType<'app-admin-connected-stores-caper-config-keys'>
  | DashRouteType<'app-admin-connected-stores-caper-features'>
  | DashRouteType<'app-admin-connected-stores-caper-feature-approvals'>
  | DashRouteType<'app-admin-connected-stores-caper-feature-dashboard'>
  | DashRouteType<'app-admin-connected-stores-caper-audit'>
  | DashRouteType<'app-admin-connected-stores-caper-ban-list', { environment: string }>
  | DashRouteType<'app-admin-connected-stores-caper-notification-groups', { environment: string }>
  | DashRouteType<'app-admin-connected-stores-caper-scheduled-actions', { environment: string }>
  | DashRouteType<'app-admin-connected-stores-caper-config-create'>
  | DashRouteType<'app-admin-connected-stores-caper-config-partner'>
  | DashRouteType<'app-admin-connected-stores-caper-config-retailer'>
  | DashRouteType<'app-admin-connected-stores-caper-config-store'>
  | DashRouteType<'app-admin-connected-stores-caper-config-device'>

  // Upos
  | DashRouteType<'app-admin-connected-stores-upos-status', { id: string | null }>
  | DashRouteType<'app-admin-connected-stores-upos-retailers', { id: string | null }>
  | DashRouteType<'app-admin-connected-stores-upos-profiles', { id: string | null }>
  | DashRouteType<'app-admin-connected-stores-upos-stores', { id: string | null }>
  | DashRouteType<'app-admin-connected-stores-upos-integrations', { id: string | null }>
  | DashRouteType<'app-admin-connected-stores-unified-barcodes'>

  // Shelf Labels
  | DashRouteType<'app-admin-connected-stores-shelf-labels-stores', { id: string | null }>
  | DashRouteType<'app-admin-connected-stores-shelf-labels-connections', { id: string | null }>
  | DashRouteType<'app-admin-connected-stores-shelf-labels-sync-strategies', { id: string | null }>
  | DashRouteType<'app-admin-connected-stores-shelf-labels-automations', { id: string | null }>

  // Not on File
  | DashRouteType<'app-admin-connected-stores-not-on-file', { environment: string }>
  | DashRouteType<
      'app-admin-connected-stores-not-on-file-details',
      { environment: string; id: string }
    >
  | DashRouteType<'app-retailer-scope-connected-stores-not-on-file', { environment: string }>
  | DashRouteType<
      'app-retailer-scope-connected-stores-not-on-file-details',
      { environment: string; id: string }
    >
  | DashRouteType<'app-retailer-scope-connected-stores-caper-transactions'>
  | DashRouteType<'app-partner-scope-connected-stores-not-on-file', { environment: string }>
  | DashRouteType<
      'app-partner-scope-connected-stores-not-on-file-details',
      { environment: string; id: string }
    >
  // Inventory Intelligence
  | DashRouteType<'app-retailer-scope-connected-stores-inventory-intelligence', { storeId: string }>

  // Staff Barcode Management
  | DashRouteType<'app-retailer-scope-connected-stores-staff-barcode-management'>

  // Payment Terminals
  | DashRouteType<'app-admin-connected-stores-caper-payment-terminals', { environment: string }>
  | DashRouteType<
      'app-admin-connected-stores-caper-payment-terminals-details',
      { environment: string; id: string }
    >

  // Device Provisioning Pipeline
  | DashRouteType<
      'app-admin-connected-stores-device-provisioning-pipeline',
      { environment: string }
    >
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'app-admin-connected-stores': URL_CONNECTED_STORES,
  'app-retailer-scope-connected-stores': URL_CONNECTED_STORES_RETAILER_SCOPE,
  'app-partner-scope-connected-stores': URL_CONNECTED_STORES_PARTNER_SCOPE,

  // Caper
  'app-admin-connected-stores-caper': URL_CONNECTED_STORES_CAPER,
  'app-admin-connected-stores-caper-session-replay': URL_CONNECTED_STORES_CAPER_SESSION_REPLAY,
  'app-admin-connected-stores-caper-config': URL_CONNECTED_STORES_CAPER_CONFIG,
  'app-admin-connected-stores-caper-config-keys': URL_CONNECTED_STORES_CAPER_CONFIG_KEYS,
  'app-admin-connected-stores-caper-features': URL_CONNECTED_STORES_CAPER_FEATURES,
  'app-admin-connected-stores-caper-feature-approvals':
    URL_CONNECTED_STORES_CAPER_FEATURE_APPROVALS,
  'app-admin-connected-stores-caper-feature-dashboard':
    URL_CONNECTED_STORES_CAPER_FEATURE_DASHBOARD,
  'app-admin-connected-stores-caper-audit': URL_CONNECTED_STORES_CAPER_AUDIT,
  'app-admin-connected-stores-caper-ban-list': URL_CONNECTED_STORES_CAPER_BAN_LIST,
  'app-admin-connected-stores-caper-notification-groups':
    URL_CONNECTED_STORES_CAPER_NOTIFICATION_GROUPS,
  'app-admin-connected-stores-caper-scheduled-actions':
    URL_CONNECTED_STORES_CAPER_SCHEDULED_ACTIONS,
  'app-admin-connected-stores-caper-config-create': URL_CONNECTED_STORES_CAPER_CONFIG_CREATE,
  'app-admin-connected-stores-caper-config-partner': URL_CONNECTED_STORES_CAPER_CONFIG_PARTNER,
  'app-admin-connected-stores-caper-config-retailer': URL_CONNECTED_STORES_CAPER_CONFIG_RETAILER,
  'app-admin-connected-stores-caper-config-store': URL_CONNECTED_STORES_CAPER_CONFIG_STORE,
  'app-admin-connected-stores-caper-config-device': URL_CONNECTED_STORES_CAPER_CONFIG_DEVICE,

  // Upos
  'app-admin-connected-stores-upos-status': URL_CONNECTED_STORES_UPOS_STATUS,
  'app-admin-connected-stores-upos-retailers': URL_CONNECTED_STORES_UPOS_RETAILERS,
  'app-admin-connected-stores-upos-profiles': URL_CONNECTED_STORES_UPOS_PROFILES,
  'app-admin-connected-stores-upos-stores': URL_CONNECTED_STORES_UPOS_STORES,
  'app-admin-connected-stores-upos-integrations': URL_CONNECTED_STORES_UPOS_INTEGRATIONS,

  // Unified Barcodes
  'app-admin-connected-stores-unified-barcodes': URL_CONNECTED_STORES_UNIFIED_BARCODES,

  // Shelf Labels
  'app-admin-connected-stores-shelf-labels-stores': URL_CONNECTED_STORES_SHELF_LABELS_STORES,
  'app-admin-connected-stores-shelf-labels-connections':
    URL_CONNECTED_STORES_SHELF_LABELS_CONNECTIONS,
  'app-admin-connected-stores-shelf-labels-sync-strategies':
    URL_CONNECTED_STORES_SHELF_LABELS_SYNC_STRATEGIES,
  'app-admin-connected-stores-shelf-labels-automations':
    URL_CONNECTED_STORES_SHELF_LABELS_AUTOMATIONS,

  // Not on File
  'app-admin-connected-stores-not-on-file': URL_CONNECTED_STORES_NOT_ON_FILE,
  'app-admin-connected-stores-not-on-file-details': URL_CONNECTED_STORES_NOT_ON_FILE_DETAILS,
  'app-retailer-scope-connected-stores-not-on-file':
    URL_CONNECTED_STORES_RETAILER_SCOPE_NOT_ON_FILE,
  'app-retailer-scope-connected-stores-not-on-file-details':
    URL_CONNECTED_STORES_RETAILER_SCOPE_NOT_ON_FILE_DETAILS,

  // Caper Transactions
  'app-retailer-scope-connected-stores-caper-transactions':
    URL_CONNECTED_STORES_RETAILER_SCOPE_CAPER_TRANSACTIONS,

  // Not on File (Partner Scope)
  'app-partner-scope-connected-stores-not-on-file': URL_CONNECTED_STORES_PARTNER_SCOPE_NOT_ON_FILE,
  'app-partner-scope-connected-stores-not-on-file-details':
    URL_CONNECTED_STORES_PARTNER_SCOPE_NOT_ON_FILE_DETAILS,

  // Inventory Intelligence
  'app-retailer-scope-connected-stores-inventory-intelligence':
    URL_CONNECTED_STORES_RETAILER_SCOPE_INVENTORY_INTELLIGENCE,

  // Staff Barcode Management
  'app-retailer-scope-connected-stores-staff-barcode-management':
    URL_CONNECTED_STORES_RETAILER_SCOPE_STAFF_BARCODE_MANAGEMENT,

  // Payment Terminals
  'app-admin-connected-stores-caper-payment-terminals': URL_CONNECTED_STORES_PAYMENT_TERMINALS,
  'app-admin-connected-stores-caper-payment-terminals-details':
    URL_CONNECTED_STORES_PAYMENT_TERMINALS_DETAILS,

  // Device Provisioning Pipeline
  'app-admin-connected-stores-device-provisioning-pipeline':
    URL_CONNECTED_STORES_DEVICE_PROVISIONING_PIPELINE,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
